// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_kKQ","cls2":"Cta-cls2_Ok7 Cta-cls1_kKQ"};